import { useEffect } from 'react';
import { useCountUp } from 'react-countup';
import styles from './Percentage.module.css';

export const Percentage = ({ id, value, variantPersentTextColor }) => {
  const { start, update } = useCountUp({
    ref: `counter-${id}`,
    start: 0,
    end: value,
    duration: 1,
    suffix: '%',
  });

  useEffect(() => {
    start();
  }, [start]);

  useEffect(() => {
    update(value);
  }, [update, value]);

  return (
    <div
      className={styles['percentage']}
      id={`counter-${id}`}
      style={{ color: variantPersentTextColor }}
    />
  );
};
